<template>
    <base-button type="success" size="lg" @click="handleClick">
        <i class="fa fa-save fa-fw"></i>{{text}}
    </base-button>
</template>
<script>
export default {
    props: {
        text: {
            type: String,
            default: 'Guardar'
        }
    },    
    name: "save-button",
    methods: {
        handleClick(evt) {
            this.$emit("click", evt);
        }
    }
};
</script>
<style>
</style>